export enum SearchScope {
  ALL = 0,
  ONLY_TITLE = 1,
  CONTAINS_TEXT = 2
}
